(() => {
// Main Menu
const $3290158d6660df5d$export$9d8e10a1281777d0 = (selector)=>{
    if (selector !== null && selector !== undefined) return true;
    else return false;
};
const $3290158d6660df5d$export$d16800b7e59a8051 = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelector(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $3290158d6660df5d$export$73eac51a39d6b0eb = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelectorAll(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $3290158d6660df5d$export$1d567c320f4763bc = (el, property)=>window.getComputedStyle(el).getPropertyValue(property);
const $3290158d6660df5d$export$28ee1007e174a2a6 = (callback)=>{
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
const $3290158d6660df5d$export$4d721c3bfe35a861 = (e)=>{
    e.cancelable !== false && e.preventDefault();
    e.stopPropagation();
};
const $3290158d6660df5d$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(()=>{
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    //alert("!");
    }, duration);
};
const $3290158d6660df5d$export$abdd11a06a163232 = (target, duration = 500, displayStyle = "block")=>{
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = displayStyle;
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(()=>{
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};
const $3290158d6660df5d$export$715de50cedc228a8 = (target, duration = 500, displayStyle = "block")=>{
    if (window.getComputedStyle(target).display === "none") return $3290158d6660df5d$export$abdd11a06a163232(target, duration, displayStyle);
    else return $3290158d6660df5d$export$deed561b1a0ff1ea(target, duration);
};
const $3290158d6660df5d$export$8c8705df4a2dcec9 = function(event, elem, callback, capture) {
    if (typeof elem === "function") {
        capture = callback;
        callback = elem;
        elem = window;
    }
    capture = capture ? true : false;
    elem = typeof elem === "string" ? document.querySelector(elem) : elem;
    if (!elem) return;
    elem.removeEventListener(event, callback, capture);
};
const $3290158d6660df5d$export$a41d61df4ac70627 = (date)=>{
    let dateObj = void 0;
    if (typeof date === "string") dateObj = new Date(date);
    else dateObj = date;
    let options = {
        month: "long",
        day: "numeric"
    };
    let dateYear = dateObj.toLocaleString("latn", {
        year: "numeric"
    });
    let dateMonth = dateObj.toLocaleString("latn", {
        month: "numeric"
    });
    let dateDay = dateObj.toLocaleString("latn", {
        day: "numeric"
    });
    let dateHour = dateObj.getHours();
    let dateMinute = dateObj.getMinutes();
    let now = new Date();
    let nowYear = now.toLocaleString("latn", {
        year: "numeric"
    });
    let nowMonth = now.toLocaleString("latn", {
        month: "numeric"
    });
    let nowDay = now.toLocaleString("latn", {
        day: "numeric"
    });
    let nowHour = now.getHours();
    let nowMinute = now.getMinutes();
    // set year only if not the same year as now
    if (dateYear !== nowYear) options.year = "numeric";
    // if today, display relative time
    if (dateYear === nowYear && dateMonth === nowMonth && dateDay === nowDay) {
        let diffHour = nowHour - dateHour;
        let diffMinute = Math.abs(nowMinute - dateMinute);
        if (diffHour === 0 && diffMinute > 30) return "1 h";
        else if (diffHour === 0) return diffMinute + " min";
        else if (diffMinute >= 30) return diffHour + 1 + " h";
        return diffHour + " h";
    }
    return dateObj.toLocaleString("latn", options);
};
const $3290158d6660df5d$export$110700823644f4a6 = (name, value, days)=>{
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
const $3290158d6660df5d$export$4be65e66cfa2648a = (name)=>{
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $3290158d6660df5d$export$84a9c3647d39324f = (name)=>{
    document.cookie = name + "=; Max-Age=-99999999;";
};
const $3290158d6660df5d$export$411a36e344f94698 = window.innerWidth;
const $3290158d6660df5d$export$3f99968195accfaf = (element, to, duration)=>{
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        $3290158d6660df5d$export$3f99968195accfaf(element, to, duration - 10);
    }, 10);
};
const $3290158d6660df5d$export$c091916f1530334c = (el)=>{
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= 0.1) < 0) el.style.display = "none";
        else requestAnimationFrame(fade);
    })();
};
const $3290158d6660df5d$export$82e6205b15e6c637 = (el, display)=>{
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) >= 1)) {
            if (!((val += 0.1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        }
    })();
};
const $3290158d6660df5d$export$4140e97b68e1124c = ()=>{
    const allElements = Array.prototype.slice.call(document.querySelectorAll("*"));
    allElements.push(document);
    allElements.push(window);
    const types = [];
    for(let ev in window)if (/^on/.test(ev)) types[types.length] = ev;
    let elements = [];
    for(let i = 0; i < allElements.length; i++){
        const currentElement = allElements[i];
        for(let j = 0; j < types.length; j++)if (typeof currentElement[types[j]] === "function") elements.push({
            node: currentElement,
            type: types[j],
            func: currentElement[types[j]].toString()
        });
    }
    return elements.sort(function(a, b) {
        return a.type.localeCompare(b.type);
    });
};


const $e35308c1fa7ba673$export$170a62214c07b99b = ()=>{
    const menuButton = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#main-menu-button");
    const menu = (0, $3290158d6660df5d$export$d16800b7e59a8051)("nav.main-menu");
    function menuOpen() {
        (0, $3290158d6660df5d$export$d16800b7e59a8051)("body").classList.add("overflow-hidden");
        menu.classList.add("open");
        menuButton.classList.add("open");
        window.addEventListener("click", closeOnBackgroundClick);
    }
    function menuClose() {
        (0, $3290158d6660df5d$export$d16800b7e59a8051)("body").classList.remove("overflow-hidden");
        menuButton.classList.remove("open");
        menu.classList.remove("open");
        setMenuLevel(0);
        menuCloseSubmenus();
        menu.scrollTo(0, 0);
        (0, $3290158d6660df5d$export$8c8705df4a2dcec9)("click", window, closeOnBackgroundClick);
    }
    function setMenuLevel(n) {
        menu.classList.remove("active-level-1", "active-level-2", "active-level-3");
        function inArray(needle, haystack) {
            if (haystack.indexOf(needle) !== -1) return true;
            else return false;
        }
        if (inArray(n, [
            1,
            2,
            3
        ])) menu.classList.add("active-level-" + n);
    }
    function menuOpenSubmenu(submenuAlias) {
        var submenu = menu.querySelector("[data-alias=" + submenuAlias + "]");
        if (submenu.length !== null) {
            var levelBlock = submenu.closest("div[data-level]");
            levelBlock.classList.add("open");
            if (levelBlock.querySelector("ul.visible") !== null) levelBlock.querySelector("ul.visible").classList.remove("visible");
            submenu.classList.add("visible");
        }
    }
    function menuCloseSubmenus(closeLevels) {
        closeLevels = typeof closeLevels !== "undefined" ? closeLevels : 0;
        var levelBlocks = menu.querySelectorAll("[class*=level-]");
        Array.from(levelBlocks).forEach((elem)=>{
            var levelBlock = elem;
            if (closeLevels <= parseInt(levelBlock.getAttribute("data-level"))) {
                levelBlock.classList.remove("open");
                if (levelBlock.querySelector("ul.open") !== null) levelBlock.querySelector("ul.open").classList.remove("open");
                if (levelBlock.querySelector(".o-sub.open")) levelBlock.querySelector(".o-sub.open").classList.remove("open");
            }
        });
    }
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(menuButton)) menuButton.addEventListener("click", (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (menuButton.classList.contains("open")) menuClose();
        else {
            menuOpen();
            setMenuLevel(1);
        }
    });
    const subMenus = document.querySelectorAll(".o-sub[data-target-alias]");
    // click on subMenu
    if (subMenus !== null) Array.from(subMenus).forEach((link)=>{
        link.addEventListener("click", function(event) {
            let parentTitle = link.getAttribute("data-item-title");
            let parentUrl = link.getAttribute("data-url");
            if (parentTitle != null && parentTitle != undefined && parentUrl != undefined && parentUrl != null) {
                let parentAlias = link.getAttribute("data-target-alias");
                let levelTitle = document.querySelector(`[data-alias=${parentAlias}] .level-url`);
                levelTitle.textContent = parentTitle;
                levelTitle.setAttribute("href", parentUrl);
            }
            event.preventDefault();
            event.stopPropagation();
            let elementAlias = this.getAttribute("data-target-alias"), levelBlock = this.closest("div[class*=level-]");
            if (this.classList.contains("open")) {
                setMenuLevel(parseInt(levelBlock.getAttribute("data-level")));
                this.classList.remove("open");
                menuCloseSubmenus(parseInt(levelBlock.getAttribute("data-level")));
            } else {
                setMenuLevel(parseInt(levelBlock.getAttribute("data-level")) + 1);
                menuCloseSubmenus(parseInt(levelBlock.getAttribute("data-level")));
                menuOpenSubmenu(elementAlias);
                if (levelBlock.querySelector(".o-sub[data-target-alias].open") !== null) levelBlock.querySelector(".o-sub[data-target-alias].open").classList.remove("open");
                this.classList.add("open");
            }
        });
    });
    // Close menu by click on background
    function closeOnBackgroundClick(e) {
        if (e.target.closest("#main-menu-button") !== null && e.target.closest(".o-sub") !== null && e.target.closest("nav.main-menu") !== null || e.target.classList.contains("wrapper")) menuClose();
    }
    // Mobile back buttons
    if (menu != null && menu != undefined && menu.querySelector(".evt-close-level") != null) {
        let closeSubmenuArrowSelector = menu.querySelectorAll(".evt-close-level");
        Array.from(closeSubmenuArrowSelector).forEach((item)=>{
            item.addEventListener("click", function(e) {
                e.stopPropagation();
                e.preventDefault();
                var currentLevel = parseInt(item.getAttribute("data-current-level"));
                setMenuLevel(currentLevel - 1);
                menuCloseSubmenus(currentLevel - 1);
            });
        });
    }
};
const $e35308c1fa7ba673$export$f40e957e8c490719 = ()=>{
//   let headerSelector = getElement('header');
//   if (ifSelectorExist(headerSelector)) {
//     let itemsHasChildren = getElements('.menu-item-has-children');
//     if (ifSelectorExist(itemsHasChildren)) {
//       Array.from(itemsHasChildren).forEach((item) => {
//         let subMenuSelector = getElement('.sub-menu', item);
//         if (ifSelectorExist(subMenuSelector)) {
//           subMenuSelector.style.top = headerSelector.clientHeight + 'px';
//         }
//       });
//     }
//   }
};


// Main Menu

function $d43b5c64f3155d17$export$2e2bcd8739ae039() {
    const header = (0, $3290158d6660df5d$export$d16800b7e59a8051)("header");
    const body = (0, $3290158d6660df5d$export$d16800b7e59a8051)("body");
    let isSticked = false;
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(header) && (0, $3290158d6660df5d$export$9d8e10a1281777d0)(header)) document.addEventListener("scroll", (e)=>{
        if (!isSticked && window.scrollY >= 46) {
            header.classList.add("sticked");
            body.classList.add("menu-sticked");
            isSticked = true;
        }
        if (isSticked && window.scrollY <= 50) {
            header.classList.remove("sticked");
            body.classList.remove("menu-sticked");
            isSticked = false;
        }
    });
}




const $f15ae3a3939537c0$export$9e5906ac48805b9b = (data)=>{
    // Success entry
    document.addEventListener("wpcf7mailsent", function(event) {
        var obj = event.detail.inputs;
        var result = Object.keys(obj).map((key)=>[
                Number(key),
                obj[key]
            ]);
        console.log("inputs = ", result);
        saveSuccessEntry(obj);
    }, false);
    async function saveSuccessEntry(inputsData) {
        let inputData = inputsData;
        let data = {
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(inputData)
        };
        let response = await fetch(ajax_url.ajaxurl + "?action=form_entry_sucess", data);
    // let serverResponse = await response.text();
    }
    //   Fail Entry
    document.addEventListener("wpcf7mailfailed", function(event) {
        var obj = event.detail.inputs;
        var result = Object.keys(obj).map((key)=>[
                Number(key),
                obj[key]
            ]);
        saveFailEntry(obj);
    }, false);
    async function saveFailEntry(inputsData) {
        let inputData = inputsData;
        let data = {
            method: "POST",
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(inputData)
        };
        let response = await fetch(ajax_url.ajaxurl + "?action=form_entry_fail", data);
    // let serverResponse = await response.text();
    }
};
const $f15ae3a3939537c0$export$fab88fceae37b395 = ()=>{
    document.addEventListener("submit", function(event) {
        if (event.target.matches(".wpcf7-form")) {
            let submitButton = event.target.querySelector("[type=submit]");
            if (!(0, $3290158d6660df5d$export$9d8e10a1281777d0)(submitButton)) return;
            submitButton.setAttribute("disabled", true);
            submitButton.classList.add("sending");
        }
    });
    document.addEventListener("wpcf7submit", function(event) {
        let form = event.target.closest(".wpcf7");
        if (form) {
            let submitButton = form.querySelector("[type=submit]");
            if (!(0, $3290158d6660df5d$export$9d8e10a1281777d0)(submitButton)) return;
            submitButton.removeAttribute("disabled");
            submitButton.classList.remove("sending");
        }
    });
};



const $3e47ae85879fd9b0$export$b085b84307abb2c = ()=>{
    function getParam(p) {
        var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    }
    function getExpiryRecord(value) {
        var expiryPeriod = 7776000000; // 90 days
        var expiryDate = new Date().getTime() + expiryPeriod;
        return {
            value: value,
            expiryDate: expiryDate
        };
    }
    function addGclid() {
        var gclidParam = getParam("gclid");
        var gclidRecord = null;
        var gclsrcParam = getParam("gclsrc");
        var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf("aw") !== -1;
        if (gclidParam && isGclsrcValid) {
            gclidRecord = getExpiryRecord(gclidParam);
            localStorage.setItem("gclid", JSON.stringify(gclidRecord));
        }
        var gclid = gclidRecord || JSON.parse(localStorage.getItem("gclid"));
        var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;
        if (isGclidValid) {
            let formsSelector = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".wpcf7-form");
            if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(formsSelector)) Array.from(formsSelector).forEach((item)=>{
                let itemSelector1 = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".gclid_field", item);
                if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(itemSelector1)) itemSelector1.value = gclid.value;
                let itemSelector2 = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".clixsy", item);
                if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(itemSelector2)) itemSelector2.value = gclid.value;
            });
        }
    }
    window.addEventListener("load", addGclid);
};



const $77f6d3978525cda2$export$3a3f8dfd69f3fd8 = ()=>{
    let btn = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".read-more");
    let hiddenText = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".hidden-text");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(btn) && (0, $3290158d6660df5d$export$9d8e10a1281777d0)(hiddenText)) btn.addEventListener("click", ()=>{
        hiddenText.classList.toggle("hidden");
        if (!hiddenText.classList.contains("hidden")) btn.innerText = "read less";
        else btn.innerText = "read more...";
    });
};
const $77f6d3978525cda2$export$b346ae7c9d204e07 = ()=>{
    let btn = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".load-more");
    let hiddenItems = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".review-items.hidden");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(btn) && (0, $3290158d6660df5d$export$9d8e10a1281777d0)(hiddenItems)) btn.addEventListener("click", ()=>{
        hiddenItems.forEach((element)=>{
            element.classList.remove("hidden");
        });
        btn.remove();
    });
};
const $77f6d3978525cda2$export$cf31d7562bd8c2e8 = ()=>{
    let programIitemsWrapper = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".program_items_wrapper");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(programIitemsWrapper)) Array.from(programIitemsWrapper).forEach((e)=>{
        let programItems = e.querySelectorAll(".custom-list.programs ul li"), btns = e.querySelectorAll(".show-more-programs");
        if (programItems.length <= 7) btns.forEach((btn)=>{
            btn.classList.add("hidden");
        });
        programItems.forEach((element, index)=>{
            if (index >= 7) element.classList.add("hidden");
        });
        Array.from(btns).forEach((e)=>{
            e.addEventListener("click", ()=>{
                programItems.forEach((item, index)=>{
                    if (index >= 7) item.classList.toggle("hidden");
                    if (item.classList.contains("hidden")) e.textContent = "show more...";
                    else e.textContent = "show less";
                });
            });
        });
    });
};
const $77f6d3978525cda2$export$382afc083c0fb9f6 = ()=>{
    if (window.innerWidth <= 768) {
        let textContainers = document.querySelectorAll(".review-loadmore-mob");
        let maxLength = 280;
        textContainers.forEach((container)=>{
            let text = container.textContent.trim();
            if (text.length > maxLength) {
                let truncatedText = text.substring(0, maxLength);
                let remainingText = text.substring(maxLength);
                let showMoreButton = document.createElement("button");
                showMoreButton.textContent = "Show More";
                showMoreButton.onclick = function() {
                    container.textContent = truncatedText + remainingText;
                    showMoreButton.style.display = "none";
                };
                container.textContent = truncatedText + "... ";
                container.appendChild(showMoreButton);
            }
        });
    }
};


/*!
 * Glide.js v3.6.2
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $5137c3620ef83169$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5137c3620ef83169$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5137c3620ef83169$var$ownKeys(Object(source), true).forEach(function(key) {
            $5137c3620ef83169$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5137c3620ef83169$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5137c3620ef83169$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5137c3620ef83169$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $5137c3620ef83169$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5137c3620ef83169$var$_typeof(obj);
}
function $5137c3620ef83169$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5137c3620ef83169$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5137c3620ef83169$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5137c3620ef83169$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5137c3620ef83169$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5137c3620ef83169$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5137c3620ef83169$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5137c3620ef83169$var$_setPrototypeOf(subClass, superClass);
}
function $5137c3620ef83169$var$_getPrototypeOf(o) {
    $5137c3620ef83169$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5137c3620ef83169$var$_getPrototypeOf(o);
}
function $5137c3620ef83169$var$_setPrototypeOf(o, p) {
    $5137c3620ef83169$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5137c3620ef83169$var$_setPrototypeOf(o, p);
}
function $5137c3620ef83169$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5137c3620ef83169$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5137c3620ef83169$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5137c3620ef83169$var$_assertThisInitialized(self);
}
function $5137c3620ef83169$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5137c3620ef83169$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5137c3620ef83169$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5137c3620ef83169$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5137c3620ef83169$var$_possibleConstructorReturn(this, result);
    };
}
function $5137c3620ef83169$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5137c3620ef83169$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $5137c3620ef83169$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $5137c3620ef83169$var$_get = Reflect.get;
    else $5137c3620ef83169$var$_get = function _get(target, property, receiver) {
        var base = $5137c3620ef83169$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $5137c3620ef83169$var$_get.apply(this, arguments);
}
var $5137c3620ef83169$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: "",
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: {
            ltr: "glide--ltr",
            rtl: "glide--rtl"
        },
        type: {
            slider: "glide--slider",
            carousel: "glide--carousel"
        },
        slide: {
            clone: "glide__slide--clone",
            active: "glide__slide--active"
        },
        arrow: {
            disabled: "glide__arrow--disabled"
        },
        nav: {
            active: "glide__bullet--active"
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $5137c3620ef83169$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isString(value) {
    return typeof value === "string";
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$isObject(value) {
    var type = $5137c3620ef83169$var$_typeof(value);
    return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $5137c3620ef83169$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($5137c3620ef83169$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $5137c3620ef83169$var$warn("Extension must be a function");
    for(var _name in components)if ($5137c3620ef83169$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $5137c3620ef83169$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $5137c3620ef83169$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $5137c3620ef83169$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty("classes")) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        var properties = [
            "direction",
            "type",
            "slide",
            "arrow",
            "nav"
        ];
        properties.forEach(function(property) {
            if (settings.classes.hasOwnProperty(property)) options.classes[property] = $5137c3620ef83169$var$_objectSpread2($5137c3620ef83169$var$_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
        });
    }
    if (settings.hasOwnProperty("breakpoints")) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $5137c3620ef83169$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $5137c3620ef83169$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $5137c3620ef83169$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $5137c3620ef83169$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $5137c3620ef83169$var$mergeOptions($5137c3620ef83169$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit("mount.before");
                if ($5137c3620ef83169$var$isObject(extensions)) this._c = $5137c3620ef83169$var$mount(this, extensions, this._e);
                else $5137c3620ef83169$var$warn("You need to provide a object on `mount()`");
                this._e.emit("mount.after");
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($5137c3620ef83169$var$isArray(transformers)) this._t = transformers;
                else $5137c3620ef83169$var$warn("You need to provide a array on `mutate()`");
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $5137c3620ef83169$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                this._e.emit("update");
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit("destroy");
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit("play");
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit("pause");
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($5137c3620ef83169$var$isObject(o)) this._o = o;
                else $5137c3620ef83169$var$warn("Options must be an `object` instance.");
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $5137c3620ef83169$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $5137c3620ef83169$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit("run.before", this.move);
                this.calculate();
                Events.emit("run", this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit("run.start", _this.move);
                    if (_this.isEnd()) Events.emit("run.end", _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit("run.offset", _this.move);
                    }
                    Events.emit("run.after", _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === "=") {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $5137c3620ef83169$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === ">" && steps === ">") {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === "<" && steps === "<") {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === "|") viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === ">" || direction === "|" && steps === ">") {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === "<" || direction === "|" && steps === "<") {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $5137c3620ef83169$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === "|>") return this.move.direction === "|" && this.move.steps === ">";
             // did we view to the left?
            if (direction === "|<") return this.move.direction === "|" && this.move.steps === "<";
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType("slider") && Glide.settings.focusAt !== "center" && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType("carousel")) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType("carousel")) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $5137c3620ef83169$var$define(Run, "move", {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $5137c3620ef83169$var$toInt(step) ? $5137c3620ef83169$var$toInt(step) : step : 0
            };
        }
    });
    $5137c3620ef83169$var$define(Run, "length", {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($5137c3620ef83169$var$toInt(settings.perView) - 1) + $5137c3620ef83169$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $5137c3620ef83169$var$define(Run, "offset", {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $5137c3620ef83169$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout, context, args, result;
    var previous = 0;
    var later = function later() {
        previous = options.leading === false ? 0 : $5137c3620ef83169$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $5137c3620ef83169$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $5137c3620ef83169$var$MARGIN_TYPE = {
    ltr: [
        "marginLeft",
        "marginRight"
    ],
    rtl: [
        "marginRight",
        "marginLeft"
    ]
};
function $5137c3620ef83169$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = "";
                if (i !== slides.length - 1) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = "";
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = "";
                style.marginRight = "";
            }
        }
    };
    $5137c3620ef83169$var$define(Gaps, "value", {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $5137c3620ef83169$var$toInt(Glide.settings.gap);
        }
    });
    $5137c3620ef83169$var$define(Gaps, "grow", {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $5137c3620ef83169$var$define(Gaps, "reductor", {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        "build.after",
        "update"
    ], $5137c3620ef83169$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $5137c3620ef83169$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $5137c3620ef83169$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $5137c3620ef83169$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $5137c3620ef83169$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($5137c3620ef83169$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $5137c3620ef83169$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $5137c3620ef83169$var$define(Html, "root", {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($5137c3620ef83169$var$isString(r)) r = document.querySelector(r);
            if (r !== null) Html._r = r;
            else $5137c3620ef83169$var$warn("Root element must be a existing Html node");
        }
    });
    $5137c3620ef83169$var$define(Html, "track", {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            Html._t = t;
        }
    });
    $5137c3620ef83169$var$define(Html, "wrapper", {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on("update", function() {
        Html.collectSlides();
    });
    return Html;
}
function $5137c3620ef83169$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $5137c3620ef83169$var$define(Peek, "value", {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$isObject(value)) {
                value.before = $5137c3620ef83169$var$toInt(value.before);
                value.after = $5137c3620ef83169$var$toInt(value.after);
            } else value = $5137c3620ef83169$var$toInt(value);
            Peek._v = value;
        }
    });
    $5137c3620ef83169$var$define(Peek, "reductor", {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($5137c3620ef83169$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $5137c3620ef83169$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit("move", {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit("move.after", {
                    movement: _this.value
                });
            });
        }
    };
    $5137c3620ef83169$var$define(Move, "offset", {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$5137c3620ef83169$var$isUndefined(value) ? $5137c3620ef83169$var$toInt(value) : 0;
        }
    });
    $5137c3620ef83169$var$define(Move, "translate", {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $5137c3620ef83169$var$define(Move, "value", {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is("rtl")) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        "build.before",
        "run"
    ], function() {
        Move.make();
    });
    return Move;
}
function $5137c3620ef83169$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
            Components.Html.wrapper.style.width = "";
        }
    };
    $5137c3620ef83169$var$define(Sizes, "length", {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "width", {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "wrapperSize", {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "slideWidth", {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        "build.before",
        "resize",
        "update"
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
        Sizes.remove();
    });
    return Sizes;
}
function $5137c3620ef83169$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit("build.before");
            this.typeClass();
            this.activeClass();
            Events.emit("build.after");
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $5137c3620ef83169$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
        Build.activeClass();
    });
    return Build;
}
function $5137c3620ef83169$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType("carousel")) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length > 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $5137c3620ef83169$var$define(Clones, "grow", {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
        if (Glide.isType("carousel")) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
        Clones.remove();
    });
    return Clones;
}
var $5137c3620ef83169$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $5137c3620ef83169$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $5137c3620ef83169$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("resize", window, $5137c3620ef83169$var$throttle(function() {
                Events.emit("resize");
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("resize", window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $5137c3620ef83169$var$VALID_DIRECTIONS = [
    "ltr",
    "rtl"
];
var $5137c3620ef83169$var$FLIPED_MOVEMENTS = {
    ">": "<",
    "<": ">",
    "=": "="
};
function $5137c3620ef83169$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is("rtl")) return pattern.split(token).join($5137c3620ef83169$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $5137c3620ef83169$var$define(Direction, "value", {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $5137c3620ef83169$var$warn("Direction value must be `ltr` or `rtl`");
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        "build.before",
        "update"
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is("rtl")) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($5137c3620ef83169$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $5137c3620ef83169$var$Gap,
        $5137c3620ef83169$var$Grow,
        $5137c3620ef83169$var$Peeking,
        $5137c3620ef83169$var$Focusing
    ].concat(Glide._t, [
        $5137c3620ef83169$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($5137c3620ef83169$var$isFunction(transformer) && $5137c3620ef83169$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $5137c3620ef83169$var$warn("Transformer should be a function that returns an object with `modify()` method");
            }
            return translate;
        }
    };
}
function $5137c3620ef83169$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $5137c3620ef83169$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = "";
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
        if (!Glide.isType("carousel") || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit("translate.jump");
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Translate.remove();
    });
    return Translate;
}
function $5137c3620ef83169$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (disabled) return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = "";
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $5137c3620ef83169$var$define(Transition, "duration", {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        "build.before",
        "resize",
        "translate.jump"
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $5137c3620ef83169$var$supportsPassive = false;
try {
    var $5137c3620ef83169$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $5137c3620ef83169$var$supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, $5137c3620ef83169$var$opts);
    window.removeEventListener("testPassive", null, $5137c3620ef83169$var$opts);
} catch (e) {}
var $5137c3620ef83169$var$supportsPassive$1 = $5137c3620ef83169$var$supportsPassive;
var $5137c3620ef83169$var$START_EVENTS = [
    "touchstart",
    "mousedown"
];
var $5137c3620ef83169$var$MOVE_EVENTS = [
    "touchmove",
    "mousemove"
];
var $5137c3620ef83169$var$END_EVENTS = [
    "touchend",
    "touchcancel",
    "mouseup",
    "mouseleave"
];
var $5137c3620ef83169$var$MOUSE_EVENTS = [
    "mousedown",
    "mousemove",
    "mouseup",
    "mouseleave"
];
function $5137c3620ef83169$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $5137c3620ef83169$var$toInt(swipe.pageX);
                swipeStartY = $5137c3620ef83169$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit("swipe.start");
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $5137c3620ef83169$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $5137c3620ef83169$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $5137c3620ef83169$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit("swipe.move");
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit("swipe.end");
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, $5137c3620ef83169$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $5137c3620ef83169$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("dragstart", Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $5137c3620ef83169$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("click", Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("click", Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $5137c3620ef83169$var$define(Anchors, "items", {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $5137c3620ef83169$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $5137c3620ef83169$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, ' [data-glide-dir*="<"]');
var $5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, ' [data-glide-dir*=">"]');
function $5137c3620ef83169$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($5137c3620ef83169$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($5137c3620ef83169$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            item.classList.add(settings.classes.nav.active);
            $5137c3620ef83169$var$siblings(item).forEach(function(sibling) {
                sibling.classList.remove(settings.classes.nav.active);
            });
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            item === null || item === void 0 || item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on("click", elements[i], this.click);
                Binder.on("touchstart", elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                "click",
                "touchstart"
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$5137c3620ef83169$var$supportsPassive$1 && event.type === "touchstart") event.preventDefault();
            var direction = event.currentTarget.getAttribute("data-glide-dir");
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $5137c3620ef83169$var$define(Controls, "items", {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        "mount.after",
        "move.after"
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        "mount.after",
        "run"
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $5137c3620ef83169$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("keyup", document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("keyup", document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            var arrowSymbols = {
                ArrowRight: ">",
                ArrowLeft: "<"
            };
            if ([
                "ArrowRight",
                "ArrowLeft"
            ].includes(event.code)) Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $5137c3620ef83169$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($5137c3620ef83169$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make(">");
                    _this.start();
                    Events.emit("autoplay");
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on("mouseover", Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on("mouseout", Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                "mouseover",
                "mouseout"
            ], Components.Html.root);
        }
    };
    $5137c3620ef83169$var$define(Autoplay, "time", {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
            if (autoplay) return $5137c3620ef83169$var$toInt(autoplay);
            return $5137c3620ef83169$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "run.before",
        "swipe.start",
        "update"
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        "pause",
        "destroy"
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "run.after",
        "swipe.end"
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "play"
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $5137c3620ef83169$var$sortBreakpoints(points) {
    if ($5137c3620ef83169$var$isObject(points)) return $5137c3620ef83169$var$sortKeys(points);
    else $5137c3620ef83169$var$warn("Breakpoints option must be an object");
    return {};
}
function $5137c3620ef83169$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $5137c3620ef83169$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== "undefined") {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, $5137c3620ef83169$var$throttle(function() {
        Glide.settings = $5137c3620ef83169$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
        points = $5137c3620ef83169$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Binder.off("resize", window);
    });
    return Breakpoints;
}
var $5137c3620ef83169$var$COMPONENTS = {
    // Required
    Html: $5137c3620ef83169$var$Html,
    Translate: $5137c3620ef83169$var$Translate,
    Transition: $5137c3620ef83169$var$Transition,
    Direction: $5137c3620ef83169$var$Direction,
    Peek: $5137c3620ef83169$var$Peek,
    Sizes: $5137c3620ef83169$var$Sizes,
    Gaps: $5137c3620ef83169$var$Gaps,
    Move: $5137c3620ef83169$var$Move,
    Clones: $5137c3620ef83169$var$Clones,
    Resize: $5137c3620ef83169$var$Resize,
    Build: $5137c3620ef83169$var$Build,
    Run: $5137c3620ef83169$var$Run,
    // Optional
    Swipe: $5137c3620ef83169$var$Swipe,
    Images: $5137c3620ef83169$var$Images,
    Anchors: $5137c3620ef83169$var$Anchors,
    Controls: $5137c3620ef83169$var$Controls,
    Keyboard: $5137c3620ef83169$var$Keyboard,
    Autoplay: $5137c3620ef83169$var$Autoplay,
    Breakpoints: $5137c3620ef83169$var$Breakpoints
};
var $5137c3620ef83169$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $5137c3620ef83169$var$_inherits(Glide, _Core);
    var _super = $5137c3620ef83169$var$_createSuper(Glide);
    function Glide() {
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $5137c3620ef83169$var$_get($5137c3620ef83169$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $5137c3620ef83169$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($5137c3620ef83169$var$Glide$1);



function $1c9afc213a0f34ac$var$GlideAutoHeight(Glide, Components, Events) {
    const Component = {
        mount () {
            if (!Glide.settings.autoHeight) return;
            Components.Html.track.style.transition = "height 200ms ease-in-out";
            this.updateTrackHeight();
        },
        updateTrackHeight () {
            if (!Glide.settings.autoHeight) return;
            const activeSlides = Components.Html.slides.filter((slide, index)=>{
                return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView;
            });
            const newMaxHeight = activeSlides.reduce((maxHeight, slide)=>{
                return Math.max(maxHeight, slide.offsetHeight);
            }, 0);
            const glideTrack = Components.Html.track;
            if (newMaxHeight !== glideTrack.offsetHeight) glideTrack.style.height = `${newMaxHeight}px`;
        }
    };
    Events.on("run", ()=>{
        Component.updateTrackHeight();
    });
    Events.on("update", ()=>{
        Component.updateTrackHeight();
    });
    Events.on("resize", ()=>{
        Component.updateTrackHeight();
    });
    return Component;
}
const $1c9afc213a0f34ac$export$7390c9dc5a381509 = ()=>{
    const coupons_glide = ".coupons_glide";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(coupons_glide)) Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(coupons_glide)).forEach((item)=>{
        new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
            perView: 1,
            type: "slider",
            animationDuration: 1000,
            autoplay: 0
        }).mount();
    });
    const grSlider = ".google_reviews_slider";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(grSlider) && document.querySelector(grSlider) !== null) {
        let reviewsSliderPerView = parseInt(document.querySelector(grSlider).getAttribute("data-per-view"));
        if (isNaN(reviewsSliderPerView)) reviewsSliderPerView = 3;
        Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(grSlider)).forEach((item)=>{
            new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
                perView: reviewsSliderPerView,
                type: "carousel",
                slideWidth: 1020,
                breakpoints: {
                    1100: {
                        perView: reviewsSliderPerView > 1 ? reviewsSliderPerView - 1 : 1
                    },
                    768: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }
    const kenbBurnsSlider = ".banner_ken_burns_slider";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(kenbBurnsSlider)) Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(kenbBurnsSlider)).forEach((item)=>{
        new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
            perView: 1,
            type: "carousel",
            // animationDuration: 6000,
            animationTimingFunc: "cubic-bezier(100, 100, 100, 100)",
            autoplay: 10000
        }).mount();
    });
    const videosSlider = ".videos_slider";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(videosSlider)) Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(videosSlider)).forEach((item)=>{
        new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
            perView: 3,
            type: "carousel",
            breakpoints: {
                1200: {
                    perView: 2
                },
                768: {
                    perView: 1
                }
            }
        }).mount();
    });
    const mobileReviewsSlider = ".mobile_reviews_slider";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(mobileReviewsSlider)) Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(mobileReviewsSlider)).forEach((item)=>{
        new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
            perView: 1,
            type: "carousel",
            breakpoints: {
                768: {
                    perView: 1
                }
            }
        }).mount();
    });
    const mobileDealersSlider = ".mobileDealersSlider";
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(mobileDealersSlider)) Array.from((0, $3290158d6660df5d$export$73eac51a39d6b0eb)(mobileDealersSlider)).forEach((item)=>{
        new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(item, {
            perView: 4,
            type: "carousel",
            animationDuration: 1000,
            autoplay: 0
        }).mount();
    });
};


const $f539945873d685f5$var$not = {
    inert: ":not([inert]):not([inert] *)",
    negTabIndex: ':not([tabindex^="-"])',
    disabled: ":not(:disabled)"
};
var $f539945873d685f5$var$focusableSelectors = [
    `a[href]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `area[href]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `input:not([type="hidden"]):not([type="radio"])${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}${$f539945873d685f5$var$not.disabled}`,
    `input[type="radio"]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}${$f539945873d685f5$var$not.disabled}`,
    `select${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}${$f539945873d685f5$var$not.disabled}`,
    `textarea${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}${$f539945873d685f5$var$not.disabled}`,
    `button${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}${$f539945873d685f5$var$not.disabled}`,
    `details${$f539945873d685f5$var$not.inert} > summary:first-of-type${$f539945873d685f5$var$not.negTabIndex}`,
    // Discard until Firefox supports `:has()`
    // See: https://github.com/KittyGiraudel/focusable-selectors/issues/12
    // `details:not(:has(> summary))${not.inert}${not.negTabIndex}`,
    `iframe${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `audio[controls]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `video[controls]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `[contenteditable]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`,
    `[tabindex]${$f539945873d685f5$var$not.inert}${$f539945873d685f5$var$not.negTabIndex}`
];
/**
 * Set the focus to the first element with `autofocus` with the element or the
 * element itself.
 */ function $f539945873d685f5$var$focus(el) {
    (el.querySelector("[autofocus]") || el).focus();
}
/**
 * Get the first and last focusable elements within a given element.
 */ function $f539945873d685f5$var$getFocusableEdges(el) {
    // Check for a focusable element within the subtree of the given element.
    const firstEl = $f539945873d685f5$var$findFocusableEl(el, true);
    // Only if we find the first element do we need to look for the last one. If
    // there’s no last element, we set `lastEl` as a reference to `firstEl` so
    // that the returned array is still always of length 2.
    const lastEl = firstEl ? $f539945873d685f5$var$findFocusableEl(el, false) || firstEl : null;
    return [
        firstEl,
        lastEl
    ];
}
/**
 * Find the first focusable element inside the given element if `forward` is
 * truthy or the last focusable element otherwise.
 */ function $f539945873d685f5$var$findFocusableEl(el, forward) {
    // If we’re walking forward, check if this element is focusable, and return it
    // immediately if it is.
    if (forward && $f539945873d685f5$var$isFocusable(el)) return el;
    // We should only search the subtree of this element if it can have focusable
    // children.
    if ($f539945873d685f5$var$canHaveFocusableChildren(el)) {
        // Start walking the DOM tree, looking for focusable elements.
        // Case 1: If this element has a shadow root, search it recursively.
        if (el.shadowRoot) {
            // Descend into this subtree.
            let next = $f539945873d685f5$var$getNextChildEl(el.shadowRoot, forward);
            // Traverse the siblings, searching the subtree of each one for focusable
            // elements.
            while(next){
                const focusableEl = $f539945873d685f5$var$findFocusableEl(next, forward);
                if (focusableEl) return focusableEl;
                next = $f539945873d685f5$var$getNextSiblingEl(next, forward);
            }
        } else if (el.localName === "slot") {
            const assignedElements = el.assignedElements({
                flatten: true
            });
            if (!forward) assignedElements.reverse();
            for (const assignedElement of assignedElements){
                const focusableEl = $f539945873d685f5$var$findFocusableEl(assignedElement, forward);
                if (focusableEl) return focusableEl;
            }
        } else {
            // Descend into this subtree.
            let next = $f539945873d685f5$var$getNextChildEl(el, forward);
            // Traverse siblings, searching the subtree of each one
            // for focusable elements.
            while(next){
                const focusableEl = $f539945873d685f5$var$findFocusableEl(next, forward);
                if (focusableEl) return focusableEl;
                next = $f539945873d685f5$var$getNextSiblingEl(next, forward);
            }
        }
    }
    // If we’re walking backward, we want to check the element’s entire subtree
    // before checking the element itself. If this element is focusable, return
    // it.
    if (!forward && $f539945873d685f5$var$isFocusable(el)) return el;
    return null;
}
function $f539945873d685f5$var$getNextChildEl(el, forward) {
    return forward ? el.firstElementChild : el.lastElementChild;
}
function $f539945873d685f5$var$getNextSiblingEl(el, forward) {
    return forward ? el.nextElementSibling : el.previousElementSibling;
}
/**
 * Determine if an element is hidden from the user.
 */ const $f539945873d685f5$var$isHidden = (el)=>{
    // Browsers hide all non-<summary> descendants of closed <details> elements
    // from user interaction, but those non-<summary> elements may still match our
    // focusable-selectors and may still have dimensions, so we need a special
    // case to ignore them.
    if (el.matches("details:not([open]) *") && !el.matches("details>summary:first-of-type")) return true;
    // If this element has no painted dimensions, it's hidden.
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};
/**
 * Determine if an element is focusable and has user-visible painted dimensions.
 */ const $f539945873d685f5$var$isFocusable = (el)=>{
    // A shadow host that delegates focus will never directly receive focus,
    // even with `tabindex=0`. Consider our <fancy-button> custom element, which
    // delegates focus to its shadow button:
    //
    // <fancy-button tabindex="0">
    //  #shadow-root
    //  <button><slot></slot></button>
    // </fancy-button>
    //
    // The browser acts as as if there is only one focusable element – the shadow
    // button. Our library should behave the same way.
    if (el.shadowRoot?.delegatesFocus) return false;
    return el.matches($f539945873d685f5$var$focusableSelectors.join(",")) && !$f539945873d685f5$var$isHidden(el);
};
/**
 * Determine if an element can have focusable children. Useful for bailing out
 * early when walking the DOM tree.
 * @example
 * This div is inert, so none of its children can be focused, even though they
 * meet our criteria for what is focusable. Once we check the div, we can skip
 * the rest of the subtree.
 * ```html
 * <div inert>
 *   <button>Button</button>
 *   <a href="#">Link</a>
 * </div>
 * ```
 */ function $f539945873d685f5$var$canHaveFocusableChildren(el) {
    // The browser will never send focus into a Shadow DOM if the host element
    // has a negative tabindex. This applies to both slotted Light DOM Shadow DOM
    // children
    if (el.shadowRoot && el.getAttribute("tabindex") === "-1") return false;
    // Elemments matching this selector are either hidden entirely from the user,
    // or are visible but unavailable for interaction. Their descentants can never
    // receive focus.
    return !el.matches(":disabled,[hidden],[inert]");
}
/**
 * Get the active element, accounting for Shadow DOM subtrees.
 * @author Cory LaViska
 * @see: https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
 */ function $f539945873d685f5$var$getActiveEl(root = document) {
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    // If there’s a shadow root, recursively find the active element within it.
    // If the recursive call returns null, return the active element
    // of the top-level Document.
    if (activeEl.shadowRoot) return $f539945873d685f5$var$getActiveEl(activeEl.shadowRoot) || document.activeElement;
    // If not, we can just return the active element
    return activeEl;
}
/**
 * Trap the focus inside the given element
 */ function $f539945873d685f5$var$trapTabKey(el, event) {
    const [firstFocusableEl, lastFocusableEl] = $f539945873d685f5$var$getFocusableEdges(el);
    // If there are no focusable children in the dialog, prevent the user from
    // tabbing out of it
    if (!firstFocusableEl) return event.preventDefault();
    const activeEl = $f539945873d685f5$var$getActiveEl();
    // If the SHIFT key is pressed while tabbing (moving backwards) and the
    // currently focused item is the first one, move the focus to the last
    // focusable item from the dialog element
    if (event.shiftKey && activeEl === firstFocusableEl) {
        // @ts-ignore: we know that `lastFocusableEl` is not null here
        lastFocusableEl.focus();
        event.preventDefault();
    } else if (!event.shiftKey && activeEl === lastFocusableEl) {
        firstFocusableEl.focus();
        event.preventDefault();
    }
}
/**
 * Find the closest element to the given element matching the given selector,
 * accounting for Shadow DOM subtrees.
 * @author Louis St-Amour
 * @see: https://stackoverflow.com/a/56105394
 */ function $f539945873d685f5$var$closest(selector, base) {
    function from(el) {
        if (!el || el === document || el === window) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        return el.closest(selector) || from(el.getRootNode().host);
    }
    return from(base);
}
const $f539945873d685f5$var$SCOPE = "data-a11y-dialog";
class $f539945873d685f5$export$2e2bcd8739ae039 {
    $el;
    id;
    previouslyFocused;
    shown;
    constructor(element){
        this.$el = element;
        this.id = this.$el.getAttribute($f539945873d685f5$var$SCOPE) || this.$el.id;
        this.previouslyFocused = null;
        this.shown = false;
        this.maintainFocus = this.maintainFocus.bind(this);
        this.bindKeypress = this.bindKeypress.bind(this);
        this.handleTriggerClicks = this.handleTriggerClicks.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.$el.setAttribute("aria-hidden", "true");
        this.$el.setAttribute("aria-modal", "true");
        this.$el.setAttribute("tabindex", "-1");
        if (!this.$el.hasAttribute("role")) this.$el.setAttribute("role", "dialog");
        document.addEventListener("click", this.handleTriggerClicks, true);
    }
    /**
     * Destroy the current instance (after making sure the dialog has been hidden)
     * and remove all associated listeners from dialog openers and closers
     */ destroy() {
        // Dispatch a `destroy` event
        const destroyEvent = this.fire("destroy");
        // If the event was prevented, do not continue with the normal behavior
        if (destroyEvent.defaultPrevented) return this;
        // Hide the dialog to avoid destroying an open instance
        this.hide();
        // Remove the click event delegates for our openers and closers
        document.removeEventListener("click", this.handleTriggerClicks, true);
        // Clone and replace the dialog element to prevent memory leaks caused by
        // event listeners that the author might not have cleaned up.
        this.$el.replaceWith(this.$el.cloneNode(true));
        return this;
    }
    /**
     * Show the dialog element, trap the current focus within it, listen for some
     * specific key presses and fire all registered callbacks for `show` event
     */ show(event) {
        // If the dialog is already open, abort
        if (this.shown) return this;
        // Dispatch a `show` event
        const showEvent = this.fire("show", event);
        // If the event was prevented, do not continue with the normal behavior
        if (showEvent.defaultPrevented) return this;
        // Keep a reference to the currently focused element to be able to restore
        // it later
        this.shown = true;
        this.$el.removeAttribute("aria-hidden");
        this.previouslyFocused = $f539945873d685f5$var$getActiveEl();
        // Due to a long lasting bug in Safari, clicking an interactive element
        // (like a <button>) does *not* move the focus to that element, which means
        // `document.activeElement` is whatever element is currently focused (like
        // an <input>), or the <body> element otherwise. We can work around that
        // problem by checking whether the focused element is the <body>, and if it,
        // store the click event target.
        // See: https://bugs.webkit.org/show_bug.cgi?id=22261
        if (this.previouslyFocused?.tagName === "BODY" && event?.target) this.previouslyFocused = event.target;
        // Set the focus to the dialog element
        // See: https://github.com/KittyGiraudel/a11y-dialog/pull/583
        if (event?.type === "focus") this.maintainFocus(event);
        else $f539945873d685f5$var$focus(this.$el);
        // Bind a focus event listener to the body element to make sure the focus
        // stays trapped inside the dialog while open, and start listening for some
        // specific key presses (TAB and ESC)
        document.body.addEventListener("focus", this.maintainFocus, true);
        this.$el.addEventListener("keydown", this.bindKeypress, true);
        return this;
    }
    /**
     * Hide the dialog element, restore the focus to the previously active
     * element, stop listening for some specific key presses and fire all
     * registered callbacks for `hide` event
     */ hide(event) {
        // If the dialog is already closed, abort
        if (!this.shown) return this;
        // Dispatch a `hide` event
        const hideEvent = this.fire("hide", event);
        // If the event was prevented, do not continue with the normal behavior
        if (hideEvent.defaultPrevented) return this;
        this.shown = false;
        this.$el.setAttribute("aria-hidden", "true");
        // Ensure the previously focused element (if any) has a `focus` method
        // before attempting to call it to account for SVG elements
        // See: https://github.com/KittyGiraudel/a11y-dialog/issues/108
        this.previouslyFocused?.focus?.();
        // Remove the focus event listener to the body element and stop listening
        // for specific key presses
        document.body.removeEventListener("focus", this.maintainFocus, true);
        this.$el.removeEventListener("keydown", this.bindKeypress, true);
        return this;
    }
    /**
     * Register a new callback for the given event type
     */ on(type, handler, options) {
        this.$el.addEventListener(type, handler, options);
        return this;
    }
    /**
     * Unregister an existing callback for the given event type
     */ off(type, handler, options) {
        this.$el.removeEventListener(type, handler, options);
        return this;
    }
    /**
     * Dispatch and return a custom event from the DOM element associated with
     * this dialog; this allows authors to listen for and respond to the events
     * in their own code
     */ fire(type, event) {
        const customEvent = new CustomEvent(type, {
            detail: event,
            cancelable: true
        });
        this.$el.dispatchEvent(customEvent);
        return customEvent;
    }
    /**
     * Add a delegated event listener for when elememts that open or close the
     * dialog are clicked, and call `show` or `hide`, respectively
     */ handleTriggerClicks(event) {
        // We need to retrieve the click target while accounting for Shadow DOM.
        // When within a web component, `event.target` is the shadow root (e.g.
        // `<my-dialog>`), so we need to use `event.composedPath()` to get the click
        // target
        // See: https://github.com/KittyGiraudel/a11y-dialog/issues/582
        const target = event.composedPath()[0];
        const opener = $f539945873d685f5$var$closest(`[${$f539945873d685f5$var$SCOPE}-show="${this.id}"]`, target);
        const explicitCloser = $f539945873d685f5$var$closest(`[${$f539945873d685f5$var$SCOPE}-hide="${this.id}"]`, target);
        const implicitCloser = $f539945873d685f5$var$closest(`[${$f539945873d685f5$var$SCOPE}-hide]`, target) && $f539945873d685f5$var$closest('[aria-modal="true"]', target) === this.$el;
        // We use `closest(..)` (instead of `matches(..)`) so that clicking an
        // element nested within a dialog opener does cause the dialog to open, and
        // we use our custom `closest(..)` function so that it can cross shadow
        // boundaries
        // See: https://github.com/KittyGiraudel/a11y-dialog/issues/712
        if (opener) this.show(event);
        if (explicitCloser || implicitCloser) this.hide(event);
    }
    /**
     * Private event handler used when listening to some specific key presses
     * (namely ESC and TAB)
     */ bindKeypress(event) {
        // This is an escape hatch in case there are nested open dialogs, so that
        // only the top most dialog gets interacted with (`closest` is basically
        // `Element.prototype.closest()` accounting for Shadow DOM subtrees)
        if ($f539945873d685f5$var$closest('[aria-modal="true"]', $f539945873d685f5$var$getActiveEl()) !== this.$el) return;
        let hasOpenPopover = false;
        try {
            hasOpenPopover = !!this.$el.querySelector('[popover]:not([popover="manual"]):popover-open');
        } catch  {
        // Run that DOM query in a try/catch because not all browsers support the
        // `:popover-open` selector, which would cause the whole expression to
        // fail
        // See: https://caniuse.com/mdn-css_selectors_popover-open
        // See: https://github.com/KittyGiraudel/a11y-dialog/pull/578#discussion_r1343215149
        }
        // If the dialog is shown and the ESC key is pressed, prevent any further
        // effects from the ESC key and hide the dialog, unless:
        // - its role is `alertdialog`, which means it should be modal
        // - or it contains an open popover, in which case ESC should close it
        if (event.key === "Escape" && this.$el.getAttribute("role") !== "alertdialog" && !hasOpenPopover) {
            event.preventDefault();
            this.hide(event);
        }
        // If the dialog is shown and the TAB key is pressed, make sure the focus
        // stays trapped within the dialog element
        if (event.key === "Tab") $f539945873d685f5$var$trapTabKey(this.$el, event);
    }
    /**
     * If the dialog is shown and the focus is not within a dialog element (either
     * this one or another one in case of nested dialogs) or attribute, move it
     * back to the dialog container
     * See: https://github.com/KittyGiraudel/a11y-dialog/issues/177
     */ maintainFocus(event) {
        const target = event.target;
        if (!target.closest(`[aria-modal="true"], [${$f539945873d685f5$var$SCOPE}-ignore-focus-trap]`)) $f539945873d685f5$var$focus(this.$el);
    }
}
function $f539945873d685f5$var$instantiateDialogs() {
    for (const el of document.querySelectorAll("[data-a11y-dialog]"))new $f539945873d685f5$export$2e2bcd8739ae039(el);
}
if (typeof document !== "undefined") {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $f539945873d685f5$var$instantiateDialogs);
    else $f539945873d685f5$var$instantiateDialogs();
}



const $76def8daa6afb7f9$export$e67ef840c66287bf = ()=>{
    const dialogContainer = document.querySelector("#testimonialDialog");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(dialogContainer)) {
        const videoReviewsDialog = new (0, $f539945873d685f5$export$2e2bcd8739ae039)(dialogContainer);
        let fireTestimonialModalSelector = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".fireTestimonialModal");
        if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(fireTestimonialModalSelector)) Array.from(fireTestimonialModalSelector).forEach((item)=>{
            item.addEventListener("click", ()=>{
                console.log("clicked by modal button");
                let testimonialVideoIdSelector = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#testimonialVideoIdSelector");
                if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(testimonialVideoIdSelector)) {
                    let itemYtUrl = item.getAttribute("data-yt-url");
                    testimonialVideoIdSelector.src = itemYtUrl;
                }
            });
        });
        videoReviewsDialog.on("hide", function(dialogEl, event) {
            dialogEl.querySelector("iframe").contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        });
        videoReviewsDialog.on("show", function(dialogEl, event) {
            dialogEl.querySelector("iframe").onload = ()=>{
                dialogEl.querySelector("iframe").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
            };
        });
    }
};
const $76def8daa6afb7f9$export$5750a77698d64d03 = ()=>{
    let modalWindow = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".ada-modal-window");
    let modalWindowClose = (0, $3290158d6660df5d$export$d16800b7e59a8051)(".ada-modal-window--close");
    let modalWindowOpen = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".ada-modal-window--open");
    // Functions
    let openModal = ()=>{
        modalWindow.classList.add("open");
        document.body.style.overflow = "hidden";
    };
    let closeModal = ()=>{
        modalWindow.classList.add("fade-out");
        setTimeout(()=>{
            modalWindow.classList.remove("open", "fade-out");
            document.body.style.overflow = null;
        }, 300);
    };
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(modalWindowOpen)) Array.from(modalWindowOpen).forEach((item)=>{
        item.addEventListener("click", ()=>{
            openModal();
        });
    });
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(modalWindow)) {
        modalWindow.addEventListener("click", (e)=>{
            if (e.target === modalWindow) closeModal();
        });
        window.onkeydown = (e)=>{
            if (e.key === "Escape") closeModal();
        };
    }
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(modalWindowClose)) modalWindowClose.addEventListener("click", ()=>{
        closeModal();
    });
};



const $b1b8b41e84342b94$export$3eda75278f55f11b = ()=>{
    let targetSection = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".animation-line");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(targetSection)) {
        let signatureAnimation = (item)=>{
            let sectionPosition = item.getBoundingClientRect();
            if (sectionPosition.top <= (window.innerHeight || document.documentElement.clientHeight) && sectionPosition.bottom >= 0) item.classList.add("run-animation");
        };
        Array.from(targetSection).forEach((item)=>{
            // also check if page already scrolled to run animation.
            signatureAnimation(item);
            // Check if user see the block we need.
            window.addEventListener("scroll", function() {
                signatureAnimation(item);
            });
        });
    }
};


const $adc3fe8a58ba7e21$export$c7bc3774d8c0a604 = ()=>{
    // Redirect after form submit
    document.addEventListener("wpcf7mailsent", function(event) {
        // Function to handle form submission
        function handleFormSubmission(formId) {
            // Loop through the array to find a match
            if (cf7RedirectToArray != undefined && cf7RedirectToArray != null) {
                for(var i = 0; i < cf7RedirectToArray.length; i++)if (cf7RedirectToArray[i].select_form === formId) {
                    // Redirect to the corresponding link
                    if (cf7RedirectToArray[i].link_to_redirect_after_submit != null && cf7RedirectToArray[i].link_to_redirect_after_submit != undefined) window.location.href = cf7RedirectToArray[i].link_to_redirect_after_submit;
                    break; // Exit the loop once a match is found
                }
            }
        }
        var formId = event.detail.contactFormId;
        handleFormSubmission(formId);
    }, false);
};



const $6c250fd31c4e943c$export$3e617ddf5f26fc66 = ()=>{
    const blocks = document.querySelectorAll(".faq-accordion-block");
    blocks.forEach((block)=>{
        const accordions = block.querySelectorAll(".accordion-faq-item");
        const headerHeight = document.querySelector("header")?.offsetHeight || 0;
        const openAccordion = (accordion)=>{
            const content = accordion.querySelector(".accordion-faq-item-content");
            accordion.classList.add("active");
            content.style.maxHeight = content.scrollHeight + "px";
            setTimeout(()=>{
                const rect = accordion.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const offsetTop = rect.top + scrollTop - headerHeight;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }, 500);
        };
        const closeAccordion = (accordion)=>{
            const content = accordion.querySelector(".accordion-faq-item-content");
            accordion.classList.remove("active");
            content.style.maxHeight = null;
        };
        accordions.forEach((accordion)=>{
            const intro = accordion.querySelector(".accordion-faq-item-header");
            const content = accordion.querySelector(".accordion-faq-item-content");
            intro.onclick = ()=>{
                if (content.style.maxHeight) closeAccordion(accordion);
                else {
                    accordions.forEach((item)=>closeAccordion(item));
                    openAccordion(accordion);
                }
            };
        });
    });
};
const $6c250fd31c4e943c$export$d7eb2aa7e41af2c = ()=>{
    const faqItems = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)(".faq-item");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(faqItems)) faqItems.forEach(function(item) {
        item.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = item.getAttribute("data-faq-target");
            const targetElement = document.querySelector(`[data-faq-id="${targetId}"]`);
            if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(targetElement)) {
                const scrollOffset = targetElement.getBoundingClientRect().top + window.scrollY - 50;
                window.scrollTo({
                    top: scrollOffset,
                    behavior: "smooth"
                });
            }
        });
    });
};



const $8c6aefbc329ef490$export$f631dcb53c473c76 = ()=>{
    const SEisActive = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#se-widget-embed");
    if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(SEisActive)) {
        // Function to hide the loader
        function hideLoader() {
            const loader = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#SE_loader");
            if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(loader)) loader.classList.remove("open");
        }
        // Function to show the loader
        function showLoader() {
            const loader = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#SE_loader");
            if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(loader)) loader.classList.add("open");
        }
        // Callback function for the MutationObserver
        function callback(mutationsList, observer) {
            for (const mutation of mutationsList)if (mutation.type === "childList") {
                for (const node of mutation.addedNodes)// First check if node is an Element with a classList
                if (node.classList && node.classList.contains("se-widget-iframe-container")) {
                    hideLoader();
                    break;
                }
            }
        }
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the document body for childList changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Function to handle link click
        function handleLinkClick(e) {
            e.preventDefault(); // Prevent the default action of the link
            showLoader();
        }
        // FOR PRODUCTION
        const links = (0, $3290158d6660df5d$export$73eac51a39d6b0eb)('a[onclick="ScheduleEngine.show()"]');
        links.forEach((link)=>{
            link.addEventListener("click", handleLinkClick);
        });
    } else console.warn("ScheduleEngine is not defined");
};



const $11af2403eed6d249$export$8a705bc789781978 = ()=>{
    let body = document.body;
    let pageIdClass = body.className.match(/page-id-(\d+)/);
    if (pageIdClass && pageIdClass.length > 1) {
        let pageIdField = (0, $3290158d6660df5d$export$d16800b7e59a8051)("#page_id__custom");
        if ((0, $3290158d6660df5d$export$9d8e10a1281777d0)(pageIdField)) pageIdField.value = pageIdClass[1];
    }
};


console.log("parent scripts included");
// import { tocAnchor } from './toc';
// import { sentNewMessage } from './thank-you-messages';
// import { downloadPdfCoupon } from "./coupon-download-pdf"; -- not in use and extends js file up to 600kb insted of 100kb
(0, $3290158d6660df5d$export$28ee1007e174a2a6)(()=>{
    (0, $e35308c1fa7ba673$export$170a62214c07b99b)();
    (0, $e35308c1fa7ba673$export$f40e957e8c490719)();
    (0, $d43b5c64f3155d17$export$2e2bcd8739ae039)();
    (0, $f15ae3a3939537c0$export$9e5906ac48805b9b)();
    (0, $f15ae3a3939537c0$export$fab88fceae37b395)();
    // sentNewMessage('.sidebar-form');
    (0, $3e47ae85879fd9b0$export$b085b84307abb2c)();
    (0, $1c9afc213a0f34ac$export$7390c9dc5a381509)();
    (0, $77f6d3978525cda2$export$3a3f8dfd69f3fd8)();
    (0, $77f6d3978525cda2$export$b346ae7c9d204e07)();
    (0, $77f6d3978525cda2$export$cf31d7562bd8c2e8)();
    (0, $77f6d3978525cda2$export$382afc083c0fb9f6)();
    (0, $76def8daa6afb7f9$export$e67ef840c66287bf)();
    (0, $b1b8b41e84342b94$export$3eda75278f55f11b)();
    (0, $adc3fe8a58ba7e21$export$c7bc3774d8c0a604)();
    (0, $6c250fd31c4e943c$export$3e617ddf5f26fc66)();
    (0, $76def8daa6afb7f9$export$5750a77698d64d03)();
    (0, $6c250fd31c4e943c$export$d7eb2aa7e41af2c)();
    (0, $8c6aefbc329ef490$export$f631dcb53c473c76)();
    (0, $11af2403eed6d249$export$8a705bc789781978)();
});

})();
//# sourceMappingURL=main.js.map
